export default __webpack_public_path__ + "static/media/gang-rueef-de-bruune.1ab09560.webp";